import {wrapCall} from '../utils/serviceUtils';
import {api} from '../services';

export const createEngagementItem = (dsa, category, name, details) => {
  return wrapCall(
    api.post('/engagementitem', {
      dsa, category, name, details
    }),
    'create_engagement_item'
  );
};

export const updateEngagementItem = (id, dsa, name, details) => {
  return wrapCall(
    api.post(`/engagementitem/${id}`, {
      dsa, name, details
    }),
    'update_engagement_item'
  );
};

export const deleteEngagementItem = (id) => {
  return wrapCall(
    api.delete(`/engagementitem/${id}`),
    'delete_engagement_item'
  );
};



// WEBPACK FOOTER //
// ./src/actions/engagementItemActions.js